import { render, staticRenderFns } from "./EstablishmentDetail.vue?vue&type=template&id=cd93d2c2&scoped=true&lang=pug&"
import script from "./EstablishmentDetail.vue?vue&type=script&lang=coffee&"
export * from "./EstablishmentDetail.vue?vue&type=script&lang=coffee&"
import style0 from "./EstablishmentDetail.vue?vue&type=style&index=0&id=cd93d2c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd93d2c2",
  null
  
)

component.options.__file = "EstablishmentDetail.vue"
export default component.exports